import { render } from "./CustomIcon.vue?vue&type=template&id=065e6352"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"

import "./CustomIcon.vue?vue&type=style&index=0&id=065e6352&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__